import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'
import route from '../store/index'
import api from '../api/index'

Vue.use(VueRouter)
export const routes = [
  {
    path: '/',
    name:'Layout',
    component:() => import('../layout.vue'),
    redirect:{name:'list'},
    hidden: true,
    children:[
      {
        path:"/index",
        name:"index",
        component: () => import('../views/index/index.vue')
      },
      {
        path:"/blank",
        name:"blank",
        component: () => import('../views/index/blank.vue')
      },
      {
        path: '/instrumentsPanel/list',
        name: 'list',
        meta:{bread:[{name:"仪表盘",jump:''}]},
        component: () => import('../views/instrumentsPanel/list.vue')
    },
    {
      path: '/userInfo/list',
      name: 'userInfo',
      meta:{bread:[{name:"用户管理",jump:''}]},
      component: () => import('../views/userInfo/userInfo.vue')
  },
  {
    path: '/report/list',
    name: 'report',
    meta:{bread:[{name:"报告列表",jump:''}]},
    component: () => import('../views/report/list.vue')
},
  {
    path: '/distribution/management',
    name: 'distribution',
    meta:{bread:[{name:"分销管理",jump:''},{name:"分销记录",jump:''}]},
    component: () => import('../views/distribution/management.vue')
  },
  {
    path: '/distribution/set',
    name: 'distributionSet',
    meta:{bread:[{name:"分销管理",jump:''},{name:"分销设置",jump:''}]},
    component: () => import('../views/distribution/set.vue')
  },
  {
    path: '/operation/chat',
    name: 'operationChat',
    meta:{bread:[{name:"运营管理",jump:''},{name:"banner管理",jump:''}]},
    component: () => import('../views/operation/chat.vue')
  },
  {
    path: '/operation/member',
    name: 'operationMember',
    meta:{bread:[{name:"运营管理",jump:''},{name:"首页编辑",jump:''}]},
    component: () => import('../views/operation/member.vue')
  },
  {
    path: '/operation/shareGraph',
    name: 'operationShareGraph',
    meta:{bread:[{name:"运营管理",jump:''},{name:"分享图管理",jump:''}]},
    component: () => import('../views/operation/shareGraph.vue')
  },
  {
    path: "/operation/settings",
    name: "operationSettings",
    meta: {bread:[{name:"运营管理",jump:''},{name:"客服设置",jump:''}]},
    component: () => import("../views/operation/settings.vue")
  },
  {
    path: '/operation/coupon',
    name: 'operationCoupon',
    meta:{bread:[{name:"运营管理",jump:''},{name:"分享图管理",jump:''}]},
    component: () => import('../views/operation/coupon.vue')
  },
  {
    path: '/activityArea/activityArea',
    name: 'prefecture',
    meta:{bread:[{name:"专区管理",jump:''},{name:"专区列表",jump:''}]},
    component: () => import('../views/activityArea/activityArea.vue')
  },
  {
    path: '/activityArea/activityProductList',
    name: 'activityProductList',
    meta:{bread:[{name:"专区管理",jump:''},{name:"专区商品列表",jump:''}]},
    component: () => import('../views/activityArea/activityProductList.vue')
  },
  {
    path: '/prefecture/editPrefecture',
    name: 'editPrefecture',
    meta:{bread:[{name:"专区管理",jump:''},{name:"新增专区",jump:''}]},
    component: () => import('../views/prefecture/editPrefecture.vue')
  },
  {
    path: "/Platform/managementF/managementF",
    name: "managementF",
    meta: {bread:[{name:"平台商品管理",jump:''},{name:"平台商品列表",jump:''}]},
    component: () => import("../views/Platform/managementF/managementF.vue")
  },
  {
      path: "/CntManagement/tformorders/tformorders",
      name: "tformorders",
      meta: {bread:[{name:"订单管理",jump:''},{name:"平台订单列表",jump:''}]},
      component: () => import("../views/CntManagement/tformorders/tformorders.vue")
    },
    {
      path: "/CntManagement/tformorders/afterSale",
      name: "tformordersAfterSale",
      meta: {bread:[{name:"订单管理",jump:''},{name:"平台售后订单列表",jump:''}]},
      component: () => import("../views/CntManagement/tformorders/afterSale.vue")
    },
    {
      path: "/orderManagement/productOrderDetail",
      name: "order_management_product_order_detail",
      meta: {bread:[{name:"订单管理",jump:''},{name:"平台售后订单列表",jump:''},{name:"平台售后订单详情",jump:''}]},
      component: () => import("../components/productOrderDetail.vue")
    },
    {
      path: "/orderdetails",
      name: "orderdetails",
      meta: {bread:[{name:"订单管理",jump:''},{name:"订单列表",jump:'back'},{name:"订单详情",jump:''}]},
      component: () => import("../views/CntManagement/orderdetails/orderdetails.vue")
    },
    {
      path: "/CntManagement/distribution/distribution",
      name: "distribution",
      // meta:{tabBar:true,auth:false},
      meta: {bread:[{name:"订单/评论管理",jump:''},{name:"分销记录",jump:''}]},
      component: () => import("../views/CntManagement/distribution/distribution.vue")
    },
    {
      path: "/CntManagement/commentmana/commentmana",
      name: "commentmana",
      // meta:{tabBar:true,auth:false},
      meta: {bread:[{name:"订单/评论管理",jump:''},{name:"评论管理",jump:''}]},
      component: () => import("../views/CntManagement/commentmana/commentmana.vue")
    },
  
    {
      path: "/send",
      name: "send",
      meta: {bread:[{name:"订单/评论管理",jump:''},{name:"订单列表",jump:'back'},{name:"售后详情",jump:''}]},
      component: () => import("../views/CntManagement/send/send.vue")
    },
   
    {
      path: "/routeS",
      name: "routeS",
      meta: {bread:[{name:"设置",jump:''},{name:"路由管理",jump:''}]},
      component: () => import("../views/Setup/routeS/routeManagement.vue")
    },
    {
      path: "/Setup/power",
      name: "setupPower",
      meta: {bread:[{name:"设置",jump:''},{name:"管理台账号管理",jump:''}]},
      component: () => import("../views/Setup/power.vue")
    },
    {
      path: "/Setup/all",
      name: "setupAll",
      meta: {bread:[{name:"设置",jump:''},{name:"身份管理",jump:''}]},
      component: () => import("../views/Setup/all.vue")
    },
{
  path: "/Banner",
  name: "Banner",
  meta: { bread:[{name:"内容信息管理",jump:''} , {name:"banner管理",jump:''}] },
  component: () => import("../views/mantiopl/Banner/Banner.vue")
},
{
  path: "/feedback",
  name: "feedback",
  meta: { bread:[{name:"内容信息管理",jump:''} , {name:"反馈建议",jump:''}] },
  component: () => import("../views/mantiopl/feedback/feedback.vue")
},
{
  path: "/mantiopl/Reporting/reporting",
  name: "Reporting",
  meta: { bread:[{name:"内容信息管理",jump:''} , {name:"举报信息",jump:''}] },
  component: () => import("../views/mantiopl/Reporting/reporting.vue")
},
{
  path: "/mantiopl/Phonebook/Phonebook",
  name: "Phonebook",
  meta: { bread:[{name:"内容信息管理",jump:''} , {name:"电话本设置",jump:''}] },
  component: () => import("../views/mantiopl/Phonebook/Phonebook.vue")
},

{
  path: "/Platform/managementF/oductediti",
  name: "oductediti",
  // meta:{tabBar:true,auth:false},
  // meta: { bread:["平台电商管理","平台商品管理"] },
  component: () => import("../views/Platform/managementF/oductediti.vue")
},
{
  path: "/myInformation",
  name: "myInformation",
  // meta:{tabBar:true,auth:false},
  meta: {bread:[{name:"我的账户/收益信息",jump:''}]},
  component: () => import("../views/myInformation/myInformation.vue")
},
{
  path: "/myInformation/myInformationReva",
  name: "myInformationReva",
  // meta:{tabBar:true,auth:false},
  meta: {bread:[{name:"我的账户/收益信息",jump:'myInformation'},{name:"提现账号编辑",jump:''}]},
  component: () => import("../views/myInformation/myInformationReva.vue")
},
{
  path: "/cabinetList",
  name: "cabinetList",
  meta: {bread:[{name:"自助柜管理",jump:''},{name:"自助柜列表",jump:''}]},
  component: () => import("../views/cabinet/cabinetList.vue")
},
{
  path: "/cabinet/cabinetAdmin",
  name: "cabinetAdmin",
  meta: {bread:[{name:"自助柜管理",jump:''},{name:"自助柜管理员",jump:''}]},
  component: () => import("../views/cabinet/cabinetAdmin.vue")
},
{
  path: "/cabinet/cabinetRecord",
  name: "cabinetRecord",
  meta: {bread:[{name:"自助柜管理",jump:''},{name:"柜子使用记录",jump:''}]},
  component: () => import("../views/cabinet/cabinetRecord.vue")
},
    ],
  },
  {
    path: '/Login',
    name: 'Login',
    component: () => import('../login.vue')
  },
  
]
const router = new VueRouter({
  routes
})
// 路由拦截
router.beforeEach((to,from,next) =>{
  let arr = JSON.parse(localStorage.getItem('routeList'))
  let routeID =localStorage.getItem('rouId')
  let toPage = to.path 
  let a = [true]
  if(arr) {
    arr.forEach(e =>{
      if(!e.menuInfoList) return
      a.push(e.menuInfoList.some(obj =>{
        // 存在路由时存储按钮
        if(obj.jump === toPage) {
          api.setup.menuBar().then(res => {
            console.log(res)
            let data = res.data.data
            data.forEach(child =>{
              if(Number(child.id) === Number(routeID)) {
                if(obj.menuInfoList) {
                  let childData = child.roule.split(',')
                  let control = []
                  obj.menuInfoList.forEach(son =>{
                    childData.forEach(sonCd =>{
                      if(Number(sonCd) === son.id) {
                        control.push(son.jump)
                      }
                    })
                  })
                  route.commit('savePageButton', control)
                }
              }
            })
          })
        }
        return obj.jump === toPage
      }
      ))
    })
  }
  console.log(a,'a')
  if(
      a.includes(true) || toPage === '/index' || 
      toPage === '/Login' || toPage === '/blank' ||  toPage === '/instrumentsPanel/list'
      )
    {
    next()
  }
})
export default router




// WEBPACK FOOTER //
// ./src/router/index.js